import { JointTexture, LayingPattern, Filter, MixedColour } from 'CommonData/poco/index';

export class ProductTexture {
    public textureKey: string;
    public productId: string;
    public name: string;
    public colour: string;
    public productName: string;
    public layingPatterns: Array<LayingPattern>;
    public materialSwatchImageUrl: string;
    public skuSwatchImageUrl: string;
    public rigidJointTextures: Array<JointTexture>;
    public flexibleJointTextures: Array<JointTexture>;
    public rigidJointWidthMM: number;
    public flexibleJointWidthMM: number;
    public maskId: number;
    public filters: Array<Filter>;
    public websiteUrl: string;
    public isVisualisationTexture: boolean;
    public hasMaterialTextureKey: boolean;
    public hasDiffuseMaterialSwatchImageUrl: boolean;
    public mixedColours: Array<MixedColour>;
    public hasMixedColours: boolean;
    public categoryType: string;
    public commercialSampleSku: string;

    constructor(
            { textureKey, productId, productName, name, colour, layingPatterns, materialSwatchImageUrl, skuSwatchImageUrl, rigidJointTextures, flexibleJointTextures, rigidJointWidthMM, flexibleJointWidthMM, maskId, filters, websiteUrl, isVisualisationTexture, mixedColours, categoryType, commercialSampleSku } : 
            { textureKey: string, productId: string, productName?: string, name?: string, colour?: string, layingPatterns?: Array<LayingPattern>, materialSwatchImageUrl?: string, skuSwatchImageUrl?: string, rigidJointTextures?: Array<JointTexture>, flexibleJointTextures?: Array<JointTexture>, rigidJointWidthMM?: number, flexibleJointWidthMM?: number, maskId?: number, filters?: Array<Filter>, websiteUrl?: string, isVisualisationTexture?: boolean, mixedColours?: Array<MixedColour>, categoryType?: string, commercialSampleSku?: string }
        ) {
        this.textureKey = textureKey;
        this.productId = productId;
        this.productName = productName;
        this.name = name;
        this.colour = colour;
        this.layingPatterns = layingPatterns;
        this.materialSwatchImageUrl = materialSwatchImageUrl;
        this.skuSwatchImageUrl = skuSwatchImageUrl;
        this.rigidJointTextures = rigidJointTextures;
        this.flexibleJointTextures = flexibleJointTextures;
        this.rigidJointWidthMM = rigidJointWidthMM;
        this.flexibleJointWidthMM = flexibleJointWidthMM;
        this.maskId = maskId;
        this.filters = filters;
        this.websiteUrl = websiteUrl;
        this.isVisualisationTexture = isVisualisationTexture;
        this.hasMaterialTextureKey = !!this.materialSwatchImageUrl;
        this.hasDiffuseMaterialSwatchImageUrl = this.materialSwatchImageUrl.includes('_diffuse');
        this.mixedColours = mixedColours;
        this.hasMixedColours = this.mixedColours && !!this.mixedColours.length;
        this.categoryType = categoryType;
        this.commercialSampleSku = commercialSampleSku;
    }

    public isValidProductTexture(): boolean {
        return this.isVisualisationTexture && this.layingPatterns && this.layingPatterns.length > 0;
    }

    public getDefaultJointTexture(): JointTexture {
        if (this.rigidJointTextures && this.rigidJointTextures.length) {
            return this.rigidJointTextures[0];
        } else if (this.flexibleJointTextures && this.flexibleJointTextures.length) {
            return this.flexibleJointTextures[0];
        }

        throw `Product Texture: ${this.textureKey} has no Joint Texture data`;
    }

    public getDefaultJointTextureWidth(): number {
        if (this.rigidJointTextures && this.rigidJointTextures.length) {
            return this.rigidJointWidthMM;
        } else if (this.flexibleJointTextures && this.flexibleJointTextures.length) {
            return this.flexibleJointWidthMM;
        }

        throw `Product Texture: ${this.textureKey} has no Joint Texture data`;
    }
}